var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserDesactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7101 14.465L15.3401 11.085C15.9801 11.305 16.5701 11.565 17.1101 11.845C18.0801 12.355 18.6901 13.365 18.7101 14.465ZM19.9001 18.485L18.4901 19.895L15.8801 17.295H2.7101V14.515C2.7101 13.395 3.3201 12.365 4.3201 11.855C5.6101 11.195 7.1901 10.635 8.9901 10.405L0.100098 1.51498L1.5101 0.10498L19.9001 18.485ZM13.8801 15.295L10.8801 12.295C10.8201 12.295 10.7701 12.295 10.7101 12.295C8.3401 12.295 6.4201 13.025 5.2301 13.635C4.9101 13.795 4.7101 14.135 4.7101 14.515V15.295H13.8801ZM10.7101 3.29498C11.8101 3.29498 12.7101 4.19498 12.7101 5.29498C12.7101 6.15498 12.1701 6.88498 11.4101 7.16498L12.8901 8.64498C13.9901 7.93498 14.7101 6.69498 14.7101 5.29498C14.7101 3.08498 12.9201 1.29498 10.7101 1.29498C9.3101 1.29498 8.0701 2.01498 7.3601 3.11498L8.8401 4.59498C9.1201 3.83498 9.8501 3.29498 10.7101 3.29498Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserDesactivate);
export default __webpack_public_path__ + "static/media/icon_user_desactivate.d1cf0e2f99448f28a406a8edec93ff97.svg";
export { ForwardRef as ReactComponent };